import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetaxiservice() {



    const cardData = {

keyword: "Pune Taxi Service",

headingDescription:
    "Rising Cab Service provides reliable, safe, and affordable Pune Taxi Service for local travel, airport transfers, railway station pickups, and outstation journeys. We offer a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars with professional and verified drivers. With 24/7 availability, doorstep pickup across Pune, transparent pricing, and easy booking options, we ensure a smooth, comfortable, and hassle-free travel experience for all types of passengers.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular taxi destinations from Pune, known for misty hills, waterfalls, scenic valleys, and viewpoints like Tiger Point and Bhushi Dam. These twin hill stations are ideal for short trips, monsoon drives, and weekend family outings."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. Devotees travel from Pune for Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi, making it one of the most frequently booked taxi routes for spiritual travel."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a religious and cultural destination known for Trimbakeshwar Jyotirlinga, Panchavati temples, and the Godavari river ghats. It also offers vineyard tours and scenic drives, making it a balanced option for both spiritual and leisure taxi travel."
    },
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool climate. Attractions like Arthur’s Seat, Venna Lake, and Lingmala Falls make it a top taxi destination from Pune for families and couples."
    },
    {
        title: "Mumbai City Tour",
        description:
            "Mumbai is a major taxi destination from Pune known for Gateway of India, Marine Drive, Juhu Beach, and shopping hubs. It is widely used for business trips, airport transfers, and weekend leisure travel."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular taxi route from Pune for pilgrims and trekkers seeking both spiritual darshan and natural beauty."
    },
    {
        title: "Aurangabad Heritage Circuit",
        description:
            "Aurangabad is famous for UNESCO World Heritage Sites like Ajanta Caves and Ellora Caves along with Bibi Ka Maqbara. It is a major long-distance taxi destination from Pune for historical and cultural tours."
    },
    {
        title: "Goa Beach Holiday",
        description:
            "Goa is a top long-distance taxi destination from Pune known for beaches, nightlife, water sports, and scenic coastal roads. It is ideal for group tours, vacations, and luxury cab travel."
    },
    {
        title: "Lavasa Hill City",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside views, boating, colorful architecture, and peaceful surroundings. It is a short taxi trip perfect for relaxation and weekend getaways."
    },
    {
        title: "Tamhini Ghat & Mulshi",
        description:
            "Tamhini Ghat and Mulshi are scenic monsoon destinations near Pune known for waterfalls, green valleys, and dam views. They are popular short taxi routes for nature lovers and photography trips."
    }
],



services: [
{
name: "Pune Taxi Service",
description: "Rising Cab Service offers Pune Taxi Service with safe, reliable, and comfortable transportation across the city and nearby locations. Enjoy well-maintained AC vehicles, professional drivers, 24x7 availability, and doorstep pickup for hassle-free travel."
},
{
name: "Taxi Service in Pune",
description: "Book Taxi Service in Pune with Rising Cab Service for local rides, airport transfers, and daily commuting. We provide clean vehicles, trained chauffeurs, and affordable pricing for a smooth travel experience."
},
{
name: "Best Taxi Service Pune",
description: "Our Best Taxi Service Pune ensures premium travel with punctual pickups, verified drivers, and comfortable rides for families, corporate clients, and tourists across Pune city."
},
{
name: "Online Taxi Booking Pune",
description: "Rising Cab Service provides Online Taxi Booking Pune with instant confirmation, multiple vehicle options, and transparent pricing for easy and convenient ride booking anytime."
},
{
name: "Affordable Taxi Pune",
description: "Book Affordable Taxi Pune for budget-friendly travel without compromising safety or comfort. Ideal for daily commuting, airport drops, and short city trips."
},
{
name: "Local Taxi Pune",
description: "Our Local Taxi Pune service is perfect for city travel, shopping, meetings, and short-distance rides with quick response time and economical fares."
},
{
name: "24 Hour Taxi Service Pune",
description: "Rising Cab Service offers 24 Hour Taxi Service Pune with round-the-clock availability for emergency travel, late-night rides, and early morning pickups."
},
{
name: "Pune City Taxi",
description: "Book Pune City Taxi for convenient intra-city travel with clean cars, experienced drivers, and smooth navigation across all major Pune locations."
},
{
name: "Cab and Taxi Service Pune",
description: "We provide Cab and Taxi Service Pune combining comfort, safety, and affordability for all types of travel including local and outstation journeys."
},
{
name: "Reliable Taxi Pune",
description: "Rising Cab Service ensures Reliable Taxi Pune with verified drivers, GPS-enabled rides, and consistent service quality for safe transportation."
},
{
name: "Airport Taxi Pune",
description: "Book Airport Taxi Pune for timely pickups and drops to Pune Airport with 24x7 availability, comfortable vehicles, and professional drivers."
},
{
name: "Corporate Taxi Pune",
description: "Our Corporate Taxi Pune service is designed for business travel, employee transport, and office commuting with punctual and professional service."
},
{
name: "Cheap Taxi Pune",
description: "Rising Cab Service offers Cheap Taxi Pune for economical travel options without compromising safety, comfort, or reliability."
},
{
name: "Private Taxi Pune",
description: "Book Private Taxi Pune for personal, family, and business travel with dedicated vehicles and flexible travel schedules."
},
{
name: "AC Taxi Pune",
description: "Our AC Taxi Pune service ensures comfortable travel in all weather conditions with clean air-conditioned vehicles and smooth rides."
},
{
name: "Pune Airport Taxi Service",
description: "Rising Cab Service offers Pune Airport Taxi Service with reliable pickup and drop facilities, ensuring on-time airport transfers 24x7."
},
{
name: "Pune Local Taxi Service",
description: "Book Pune Local Taxi Service for daily commuting, city travel, and short-distance rides with affordable pricing and quick response."
},
{
name: "Outstation Taxi Service Pune",
description: "We provide Outstation Taxi Service Pune for long-distance travel to Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, and more with safe and comfortable rides."
},
{
name: "One Way Cab Pune",
description: "Book One Way Cab Pune for affordable drop-only travel with flexible pickup options and cost-effective intercity transportation."
},
{
name: "Luxury Cab Service Pune",
description: "Rising Cab Service offers Luxury Cab Service Pune with premium vehicles like Innova Crysta and SUV for high-comfort travel experiences."
},
{
name: "Pune Airport Pickup and Drop",
description: "Our Pune Airport Pickup and Drop service ensures timely and stress-free airport transfers with professional drivers and comfortable vehicles."
}
],

tableData: [
["Pune Taxi Service","Taxi Service in Pune"],
["Best Taxi Service Pune","Online Taxi Booking Pune"],
["Affordable Taxi Pune","Local Taxi Pune"],
["24 Hour Taxi Service Pune","Pune City Taxi"],
["Cab and Taxi Service Pune","Reliable Taxi Pune"],
["Airport Taxi Pune","Corporate Taxi Pune"],
["Cheap Taxi Pune","Private Taxi Pune"],
["AC Taxi Pune","Pune Airport Taxi Service"],
["Pune Local Taxi Service","Outstation Taxi Service Pune"],
["One Way Cab Pune","Luxury Cab Service Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune Taxi Service",
        WhyChoosedescription: "Rising Cab Service provides dependable taxi services across Pune for local travel, airport transfers, outstation journeys, corporate transportation, and sightseeing tours."
    },
    {
        WhyChooseheading: "Available for Every Travel Requirement",
        WhyChoosedescription: "Whether you need a taxi for daily commuting, family outings, business meetings, shopping trips, or weekend travel, we offer suitable transportation solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to their travel requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Services",
        WhyChoosedescription: "Our taxi services cover local Pune travel as well as outstation destinations including Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, and other cities."
    },
    {
        WhyChooseheading: "Convenient Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
        WhyChoosedescription: "All vehicles are maintained regularly to provide clean interiors, comfortable seating, and a pleasant travel experience."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Our experienced drivers focus on passenger safety, punctuality, route knowledge, and professional customer service."
    },
    {
        WhyChooseheading: "Preferred by Families and Corporate Clients",
        WhyChoosedescription: "Rising Cab Service is trusted by families, tourists, students, senior citizens, and corporate travelers throughout Pune."
    }
]
};

const faqData = [
    {
        question: "What services are included under Pune Taxi Service?",
        answer: "Our taxi services include local travel, airport transfers, railway station pickups, outstation trips, sightseeing tours, corporate transportation, and one-way travel."
    },
    {
        question: "Can I book a taxi for Pune Airport transfers?",
        answer: "Yes, airport pickup and drop services are available for Pune Airport and nearby locations."
    },
    {
        question: "Do you provide outstation taxi services from Pune?",
        answer: "Yes, outstation taxis are available for destinations across Maharashtra and various cities throughout India."
    },
    {
        question: "Which vehicle options are available for booking?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Can businesses hire taxis for corporate travel?",
        answer: "Yes, our taxi services are frequently used for meetings, conferences, employee transportation, and official travel requirements."
    },
    {
        question: "Are taxis available for railway station pickups and drops?",
        answer: "Yes, transportation services are available to and from Pune Railway Station and nearby railway terminals."
    },
    {
        question: "Can families hire larger vehicles for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, events, and group transportation."
    },
    {
        question: "Do you provide advance taxi booking facilities?",
        answer: "Yes, customers can reserve vehicles in advance for planned travel, holidays, tours, and special occasions."
    },
    {
        question: "Is pickup available across Pune and PCMC?",
        answer: "Yes, pickup facilities are available from all major residential, commercial, and business areas in Pune and Pimpri Chinchwad."
    },
    {
        question: "How can I book a Pune Taxi Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sameer Deshmukh",
        feedback:
            "Using Rising Cab Service for regular travel in Pune has been a great experience. The vehicles are clean, drivers are professional, and the service is consistently reliable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Kavita Jadhav",
        feedback:
            "From airport transfers to family outings, every ride has been comfortable and well-managed. The punctual service and customer support are truly impressive.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Taxi Service",
"image": "https://www.risingcabservice.com/assets/images/pune-taxi-service.jpg",
"description": "Book Pune Taxi Service with Rising Cab Service for safe, reliable, and affordable local and outstation travel. Enjoy 24x7 taxi service in Pune with AC sedans, SUVs, and Innova cars for airport, city, and corporate rides.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-taxi-service"
}
};






    return (
        <div>

<Helmet>
  <title>Pune Taxi Service | 24x7 Reliable Cab Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Taxi Service with Rising Cab Service for safe and affordable local, airport, and outstation travel. Get 24x7 AC cabs with professional drivers."
/>

<meta
 name="keywords"
 content="Pune taxi service, taxi service in pune, best taxi service pune, online taxi booking pune, affordable taxi pune, local taxi pune, 24 hour taxi service pune, pune city taxi, cab and taxi service pune, reliable taxi pune, airport taxi pune, corporate taxi pune, cheap taxi pune, private taxi pune, ac taxi pune, Pune Taxi Service, Best Taxi Service in Pune, Cab Service in Pune, 24x7 Taxi Service Pune, Pune Airport Taxi Service, Online Cab Booking Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetaxiservice;